import React, {
  useEffect,
} from "react";

import {
  Routes,
  Route,
  useParams,
} from "react-router-dom";

import {
  useDispatch,
  useSelector,
} from "react-redux";

import {
  fetchRestaurantTheme,
} from "../actions/themeActions";

import themeConfig from "./themeConfig";


function ThemeRouter() {

  const {
    restaurantId,
  } = useParams();


  const dispatch = useDispatch();


  const {
    loading,
    theme,
    error,
  } = useSelector(
    (state) => state.theme
  );


  useEffect(() => {

    if (restaurantId) {

      dispatch(
        fetchRestaurantTheme(
          restaurantId
        )
      );

    }

  }, [
    dispatch,
    restaurantId,
  ]);


  if (loading) {

    return (
      <div>
        Loading restaurant...
      </div>
    );

  }


  if (error) {

    return (
      <div>
        {typeof error === "string"
          ? error
          : "Unable to load restaurant."}
      </div>
    );

  }


  if (!theme) {

    return (
      <div>
        Restaurant theme not found.
      </div>
    );

  }


  const selectedTheme =
    themeConfig[theme];


  if (!selectedTheme) {

    return (
      <div>
        Theme "{theme}" is not configured.
      </div>
    );

  }


  const Layout =
    selectedTheme.Layout;

  const HomeScreen =
    selectedTheme.HomeScreen;

  const CartScreen =
    selectedTheme.CartScreen;

  const CheckoutScreen =
    selectedTheme.CheckoutScreen;

  const OrderScreen =
    selectedTheme.OrderScreen;

  const PaymentScreen =
    selectedTheme.PaymentScreen;

  const SuccessScreen =
    selectedTheme.SuccessScreen;


  return (

    <Routes>

      <Route
        element={
          <Layout />
        }
      >

        <Route
          index
          element={
            <HomeScreen />
          }
        />

        <Route
          path="cart"
          element={
            <CartScreen />
          }
        />

        <Route
          path="checkout"
          element={
            <CheckoutScreen />
          }
        />

        <Route
          path="order"
          element={
            <OrderScreen />
          }
        />

        <Route
          path="payment"
          element={
            <PaymentScreen />
          }
        />

        <Route
          path="success"
          element={
            <SuccessScreen />
          }
        />

      </Route>

    </Routes>

  );

}


export default ThemeRouter;